export default {"src":"https://cdn.jetlend.ru/_next/static/media/arrow--white.c6bc65e4.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};